// Prakash 29-10-2022 2698811066 added styling classes for buttons.
// Raghu 11/16/2022 258811066 Button Styling changes
import React, {useState, useEffect, useContext} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {Button} from '@material-ui/core';
import {DragDropContext} from 'react-beautiful-dnd';
import searchData from './WidgesData';
import ColoumnChips from '../../Dashboard/ColoumnChips';
import ResultViewChips from '../../Dashboard/ResultViewChips';
import {ThemeContext} from '../../../themes/ThemeProvider';

const NewForm = ({handleClose}) => {
  const [chipData, setChipData] = useState(searchData);
  const {reusableInputStyles} = useContext(ThemeContext);
  const initialValues = {};
  const validationSchema = Yup.object().shape({});
  const classes = reusableInputStyles();
  useEffect(() => {
    const searchArr = [];
    const col = chipData.columns[`column-1`];
    const tasks = col.taskIds.map((taskId) => chipData.tasks[taskId]);

    tasks.map((searchParam) => {
      searchArr.push(searchParam.content);
      return;
    });
  }, [chipData]);

  const onDragEnd = (result) => {
    const {destination, source, draggableId} = result;

    if (!destination) {
      return;
    }

    if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return;
    }

    const start = chipData.columns[source.droppableId];
    const finish = chipData.columns[destination.droppableId];

    if (start === finish) {
      const newTaskIds = Array.from(start.taskIds);
      newTaskIds.splice(source.index, 1);
      newTaskIds.splice(destination.index, 0, draggableId);

      const newColumn = {
        ...start,
        taskIds: newTaskIds,
      };

      const newData = {
        ...chipData,
        columns: {
          ...chipData.columns,
          [newColumn.id]: newColumn,
        },
      };

      setChipData(newData);
      return;
    }

    // Moving from one list to another
    const startTaskIds = Array.from(start.taskIds);
    // Remove dragged taskId from this array
    startTaskIds.splice(source.index, 1);
    const newStart = {
      ...start,
      taskIds: startTaskIds,
    };

    const finishTaskIds = Array.from(finish.taskIds);
    // Insert the draggable Id at destination index
    finishTaskIds.splice(destination.index, 0, draggableId);
    const newFinish = {
      ...finish,
      taskIds: finishTaskIds,
    };

    // updating the state object as per the drag
    const newState = {
      ...chipData,
      columns: {
        ...chipData.columns,
        [newStart.id]: newStart,
        [newFinish.id]: newFinish,
      },
    };
    setChipData(newState);
  };

  return (
    <div className="new-standard-textfields">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, {setSubmitting, resetForm}) => {
          resetForm({});
          setSubmitting(false);
          handleClose();
        }}
      >
        {(props) => {
          const {
            handleSubmit,
            handleReset,
            // setFieldValue,
          } = props;

          return (
            <form
              autoComplete="on"
              noValidate
              // className="row"
              onReset={handleReset}
              onSubmit={handleSubmit}
            >
              <DragDropContext onDragEnd={onDragEnd}>
                <div>
                  <ResultViewChips chipData={chipData} />
                </div>
                <div className="mt-3 mb-3">
                  <ColoumnChips chipData={chipData} />
                </div>
              </DragDropContext>
              <div className="col">
                <div className="row justify-content-center">
                  <Button
                    variant="outlined"
                    className={`reset-btn mr-2 ${classes.buttonRoot}`}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="outlined"
                    className={`search-btn ml-2 ${classes.buttonRoot}`}
                    onClick={handleClose}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </div>
  );
};

export default NewForm;
